import logo from './logo.webp';
import './App.css';
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/list" element={<SubPage />} />
        <Route path="/squad" element={<SubPage />} />
      </Routes>
    </Router>
  );
}

function LandingPage() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h2>
          Welcome to the openSuse Test Catalog
        </h2>
        <Link to="list" className="text-link">
          Browse
        </Link>
      </header>
    </div>
  );
}

function SubPage() {

  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(false); // eslint-disable-line @typescript-eslint/no-unused-vars
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, setError] = useState(null);
  const [query, setQuery] = useState('');
  //const [tests, setResults] = useState([]);
  const [expandedIndexes, setExpandedIndexes] = useState([]);
  const [expanding, setExpanding] = useState(false); // eslint-disable-line @typescript-eslint/no-unused-vars
  const [expandingAction, setExpandingAction] = useState(''); // 'expanding' or 'collapsing'
  const [showExpandingMessage, setShowExpandingMessage] = useState(false);
  const [showLoadingMessage, setShowLoadingMessage] = useState(false);

  const handleToggle = (index) => {
    if (expandedIndexes.includes(index)) {
      setExpandedIndexes(expandedIndexes.filter(i => i !== index));
    } else {
      setExpandedIndexes([...expandedIndexes, index]);
    }
  };
  
  const handleExpandCollapseAll = () => {
    const isExpanding = expandedIndexes.length !== tests.length;
    setExpandingAction(isExpanding ? 'expanding' : 'collapsing');
    setShowExpandingMessage(true);
    setExpanding(true);
  
    setTimeout(() => {
      setExpandedIndexes(isExpanding ? tests.map((_, index) => index) : []);
      setExpanding(false);
  
      // Delay hiding the message for fade-out
      setTimeout(() => setShowExpandingMessage(false), 300); // adjust for how long you want it visible
    }, 300);
  };

  const fetchTestsByTeam = async (maintainers = []) => {
    try {
      setLoading(true);
      setShowLoadingMessage(true);
      setError(null);

      // Construct the query string based on tags
      const queryString = maintainers.length > 0 ? `?maintainers=${maintainers.join(',')}` : '';
      console.log('here queryString:' + queryString + ' maintainers.length:' + maintainers.length);
      const response = await fetch(`https://backend-test-catolog.onrender.com/squad${queryString}`);
      console.log('here queryString:' + queryString + ' resposne: ' + response);
      //const response = await fetch(`http://localhost:3001/list${queryString}`);

      if (!response.ok) {
        throw new Error('Failed to fetch tests');
      }

      const data = await response.json();
      setTests(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
      setTimeout(() => setShowLoadingMessage(false), 500); // or longer if you want it to stay a bit
    }
  };

  // Event handler to fetch HPC-specific tests
  const handleKernelTeamTestsClick = () => {
    console.log('here');
    fetchTestsByTeam(['kernel-qa']);
  };

  // Function to fetch tests with optional tags
  const fetchTests = async (tags = []) => {
    try {
      setLoading(true);
      setShowLoadingMessage(true);
      setError(null);

      // Construct the query string based on tags
      const queryString = tags.length > 0 ? `?tags=${tags.join(',')}` : '';
      const response = await fetch(`https://backend-test-catolog.onrender.com/list${queryString}`);
      //const response = await fetch(`http://localhost:3001/list${queryString}`);

      if (!response.ok) {
        throw new Error('Failed to fetch tests');
      }

      const data = await response.json();
      setTests(data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
      setTimeout(() => setShowLoadingMessage(false), 500); // or longer if you want it to stay a bit
    }
  };

  const handleHPCTestsClick = () => {
    fetchTests(['hpc']);
  };

    const handleSAPTestsClick = () => {
      fetchTests(['sles4sap']);
    };

    const handleHATestsClick = () => {
      fetchTests(['ha']);
    };

    const handleAutoyastTestsClick = () => {
      fetchTests(['autoyast']);
    };

    const handlePubliccloudTestsClick = () => {
      fetchTests(['publiccloud']);
    };

    const handleContainersTestsClick = () => {
      fetchTests(['containers']);
    };

    const handleKernelTestsClick = () => {
      fetchTests(['kernel']);
    };

    const handleVirtualizationTestsClick = () => {
      fetchTests(['virtualization']);
    };

    const handleConsoleTestsClick = () => {
      fetchTests(['console']);
    };

    const handleInstallationTestsClick = () => {
      fetchTests(['installation']);
    };

    const handleMicroosTestsClick = () => {
      fetchTests(['microos']);
    };

    const handleMigrationTestsClick = () => {
      fetchTests(['migration']);
    };

    const handleOnlineMigrationTestsClick = () => {
      fetchTests(['online_migration']);
    };

    const handleNetworkTestsClick = () => {
      fetchTests(['network']);
    };

    const handleSleposTestsClick = () => {
      fetchTests(['slepos']);
    };

    const handleSystemdTestsClick = () => {
      fetchTests(['systemd_testsuite']);
    };

    const handleVirtAutotestTestsClick = () => {
      fetchTests(['virt_autotest']);
    };

    const handleManualTestsClick = () => {
      fetchTests(['manual']);
    };

  // Event handler to fetch all tests
  const handleAllTestsClick = () => {
    fetchTests(); // No tags, fetches all tests
  };

  const handleClearData = () => {
    setTests([]);
  };


  /////////////////////////////////////
    // Function to fetch tests with optional tags
    const fetchTestsText = async (tags = []) => {
      try {
        setLoading(true);
        setShowLoadingMessage(true);
        setError(null);
  
        const response = await fetch(`https://backend-test-catolog.onrender.com/api/v1/search?q=${query}`);
        //const response = await fetch(`http://localhost:3001/api/v1/search?q=${query}`);
  
        if (!response.ok) {
          throw new Error('Failed to fetch tests');
        }
  
        const data = await response.json();
        setTests(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
        setTimeout(() => setShowLoadingMessage(false), 500); // or longer if you want it to stay a bit
      }
    };

  const handleInputChange = (e) => {
    setQuery(e.target.value);
  };

  const handleTextSearchTestsClick =  async () => {
    fetchTestsText();
  };

  const handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      fetchTestsText();
    }
  };

  // const fetchData = () => {
  //   //fetch('https://backend-test-catolog.onrender.com/list')
  //   fetch('http://localhost:3001/list')
  //     .then(response => response.json())
  //     .then(data => setData(data))
  //     .catch(error => console.error('Error Fetching Data', error));
  // };

  //const insertLatestData = async () => {
  //  try {
  //    const response = await fetch('http://localhost:3001/sync-data', {
  //      method: 'POST',
  //      headers: {
  //        'Content-Type': 'application/json'
  //      },
  //      //TODO: Body will be from github parser
  //      body: JSON.stringify({testName: "New Test"})
  //    });
  //    const message = await response.text();
  //    console.log(message);
   // } catch (error) {
  //    console.error('Error adding new tests', error);
  //  }
  //};


  return(
<div>
    <nav   className="navbar navbar-light bg-white fixed-top shadow-sm p-3 d-flex justify-content-between align-items-center"
      style={{ height: '70px' }}>
      <a className="navbar-brand" href="/" style={{ marginLeft: '16.6667%' }}>Home</a>
      <a className="navbar-brand" href="/osado">OSADO</a>
      <a className="navbar-brand" href="/ltp">LTP</a>
      <a className="navbar-brand" href="/manual">Manual Tests</a>
      <input className="ms-auto" style={{ width: '200px', height: '38px' }} type="text" value={query} onChange={handleInputChange}  onKeyDown={handleEnterPress} placeholder="Search..."/>
      <button className="btn btn-success me-2" onClick={handleTextSearchTestsClick}>Search</button>
    </nav>






<div className="container-fluid" style={{ paddingTop: '90px' }}>



      <div className="row">
        <div className="col-md-2">
          <div className="section-left">

            <h3>Test by Functional Areas</h3>
            <div className="d-flex mb-3 flex-wrap ">
              <button className="btn btn-success mb-2 w-100" onClick={handleAllTestsClick}>List All Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleSAPTestsClick}>SLES4SAP Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleKernelTestsClick}>Kernel Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleHATestsClick}>HA Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleNetworkTestsClick}>Network Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handlePubliccloudTestsClick}>Public Cloud Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleHPCTestsClick}>HPC Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleAutoyastTestsClick}>Autoyast Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleInstallationTestsClick}>Installation Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleContainersTestsClick}>Containers Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleVirtualizationTestsClick}>Virtualization Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleConsoleTestsClick}>Console Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleMicroosTestsClick}>Microos Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleMigrationTestsClick}>Migration Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleOnlineMigrationTestsClick}>Online Migration Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleSleposTestsClick}>Slepos Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleSystemdTestsClick}>Systemd Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleVirtAutotestTestsClick}>VirtAutotest Tests</button>
              <button className="btn btn-success mb-2 w-100" onClick={handleManualTestsClick}>Manual Tests</button>
      </div>
          </div>
        </div>

      {/* Render loading, error, or list of tests */}
      {loading}
      {error}
      {expanding}

      <div className="col-md-8">

      <div style={{ minHeight: '65px' }}>
  {showLoadingMessage && (
    <div className="mb-3 px-3 py-2 border rounded bg-light d-flex align-items-center justify-content-center">
      <strong className="me-2">Loading test cases...</strong>
      <div className="spinner-border text-success" role="status" aria-hidden="true"></div>
    </div>
  )}

  {showExpandingMessage && (
    <div className="mb-3 px-3 py-2 border rounded bg-light d-flex align-items-center justify-content-center">
      <strong className="me-2">
        {expandingAction === 'expanding' ? 'Expanding all tests...' : 'Collapsing all tests...'}
      </strong>
      <div className="spinner-border text-secondary" role="status" aria-hidden="true"></div>
    </div>
  )}
</div>

        <div className="section-center">

{tests.length > 0 && (
  <div className="d-flex justify-content-end mt-2 mb-3">
    <button className="btn btn-danger me-2" onClick={handleClearData}>
      Clear Listed Tests
    </button>
    <button className="btn btn-secondary" onClick={handleExpandCollapseAll}>
      {expandedIndexes.length === tests.length ? 'Collapse All' : 'Expand All'}
    </button>
  </div>
)}


<ul className="list-group">
  {tests.map((test, index) => (
    <li
      key={index}
      className={`list-group-item ${expandedIndexes.includes(index) ? 'list-group-item-expanded' : ''}`} 
      onClick={() => handleToggle(index)}
    >
      <strong style={{ fontSize: '20px' }}>{test.testTool} : {test.testName}</strong>

      {/* Arrow that indicates whether the item is expandable */}
      <span className={`expand-arrow ${expandedIndexes.includes(index) ? 'expanded' : ''}`}>
        {expandedIndexes.includes(index) ? '↓' : '→'} {/* Arrow changes when expanded */}
      </span>

      <div className={`expandable mt-2 ${expandedIndexes.includes(index) ? 'open' : 'closed'}`}>
        {expandedIndexes.includes(index) && (
          <div>
            <strong>Test Description:</strong>
            <p style={{ whiteSpace: 'pre-line' }}>{test.comments}</p>
            <strong>The Last change (the last git commit date):</strong>
            <p>{test.last_commit_date}</p>
            <strong>Initial git commit date:</strong>
            <p>{test.first_commit_date}</p>
            <strong>Maintainers:</strong>
            {test.maintainer && test.maintainer.length > 0 && (
              <ul className="maintainers-list">
                {test.maintainer.map((maintainer, maintainerIndex) => (
                  <li key={maintainerIndex} className="maintainer-item">
                    {maintainer}
                  </li>
                ))}
              </ul>
            )}
            <strong>Associated tags:</strong>
            {test.tags && test.tags.length > 0 && (
              <ul className="tags-list">
                {test.tags.map((tag, tagIndex) => (
                  <li key={tagIndex} className="tag-item">
                    {tag}
                  </li>
                ))}
              </ul>
            )}
            <strong>License:</strong>
           <p>{test.license}</p>
           <strong><a href={test.full_path} target="_blank" rel="noopener noreferrer">Source code</a></strong>
           </div>
        )}
      </div>
    </li>
  ))}
</ul>

        </div>
      </div>


        <div className="col-md-2">
          <div className="section-right">
            <h3>Test by Squad</h3>
              <div className="d-flex mb-3 flex-wrap">
                <button className="btn btn-success mb-2 w-100" onClick={handleHPCTestsClick}>QE Update Validation</button>
                <button className="btn btn-success mb-2 w-100" onClick={handleSAPTestsClick}>QE YaST and Migration</button>
                <button className="btn btn-success mb-2 w-100" onClick={handleKernelTeamTestsClick}>QA Kernel</button>
                <button className="btn btn-success mb-2 w-100" onClick={handlePubliccloudTestsClick}>QE Virtualization</button>
                <button className="btn btn-success mb-2 w-100" onClick={handleKernelTestsClick}>QE Performance</button>
                <button className="btn btn-success mb-2 w-100" onClick={handleVirtualizationTestsClick}>QE Core</button>
                <button className="btn btn-success mb-2 w-100" onClick={handleVirtualizationTestsClick}>QE Containers and Public Cloud</button>
                <button className="btn btn-success mb-2 w-100" onClick={handleVirtualizationTestsClick}>QE Security</button>
                <button className="btn btn-success mb-2 w-100" onClick={handleVirtualizationTestsClick}>QE SAP & HA</button>
              </div>

          </div>
        </div>
      </div>
    </div>

    <nav
      className="navbar fixed-bottom p-2 d-flex justify-content-between"
      style={{
      background: 'linear-gradient(to top, #f8f9fa, #e9ecef)',
      boxShadow: '0 -2px 4px rgba(0,0,0,0.1)',
      height: '50px'
      }}
    >
      <span className="navbar-text">Test Catalog version 0.1</span>
      <span className="navbar-text">
        Please provide feedback and any specific requests to{' '}
        <a href="mailto:sebastian.chlad@suse.com">schlad</a>
      </span>
    </nav>

    </div>

  );

}

export default App;
